/**
 * Endpoints that issue or revoke the session's own tokens. TokenInterceptor
 * must never answer a 401 from one of these by refreshing: a refresh waits on
 * the cross-tab refresh lock, which these calls are part of (RefreshToken) or
 * already hold (StartViewAs / StopViewAs, refreshed in place by AuthService).
 */
export const TOKEN_ENDPOINTS = ['Auth/RefreshToken', 'Auth/RevokeTokens', 'Auth/StartViewAs', 'Auth/StopViewAs'];
